import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { environment } from 'src/environments/environment';
import { LLMConfigurationDto } from 'src/core/models/llm/llm-configuration.dto';

@Injectable({
  providedIn: 'root',
})
export class LLMConfigurationService {
  public isNameAvailable(id: number, name: string): Observable<boolean> {
    let encodedName = encodeURIComponent(name);
    const apiUrl = this.getApiUrl(LLMConfigurationDto) + '/' + id + '/' + encodedName;

    return this.http.get(apiUrl) as Observable<boolean>;
  }

  constructor(private http: HttpClient) {}

  protected getApiUrl(type = DtoHasApi): string {
    const apiBase = environment.apis.default.url;

    return apiBase + '/' + type.apiUrl;
  }
}
